import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from '../../Footer.styles'

const currentYear = new Date().getFullYear()

const ensureStructure = (window) => {
  window.digitalData = window.digitalData || {}
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.track = window.digitalData.track || (() => {})
}
const LegalFooter = ({ variant, onClick }) => {
  const target = variant === 'checkout' ? '_blank' : '_self'

  const onCookiePreferencesClick = (evt) => {
    onClick(evt, 'cookiePreferences')

    ensureStructure(window)
    const event = {
      eventInfo: {
        eventAction: 'Update Consent Preference',
        eventName: 'updateConsentPreference'
      }
    }
    window.digitalData.event.push(event)
    window.digitalData.track(event.eventInfo.eventName)
  }

  return (
    <Styled.Legal variant={variant}>
      <p className='no-line-height'>
        <Styled.LegalLink
          data-test='footer-privacy-hub'
          href='https://privacy-hub.sainsburys.co.uk'
          target='_blank'
          onClick={(evt) => onClick(evt, 'privacyHub')}>
          Privacy hub
        </Styled.LegalLink>
        <span aria-hidden='true'>|</span>
        <Styled.LegalLink
          data-test='footer-privacy-policy'
          href='/help/privacy-policy/'
          target={target}
          onClick={(evt) => onClick(evt, 'privacyPolicy')}>
          Privacy policy
        </Styled.LegalLink>
        <span aria-hidden='true'>|</span>
        <Styled.LegalLink
          data-test='footer-cookies-policy'
          href='/help/cookie-policy/'
          target={target}
          onClick={(evt) => onClick(evt, 'cookiePolicy')}>
          Cookies policy
        </Styled.LegalLink>
        <span aria-hidden='true'>|</span>
        <Styled.LegalLink
          data-test='footer-cookie-list'
          href='/help/cookie-list/'
          target={target}
          onClick={(evt) => onClick(evt, 'listOfCookies')}>
          List of cookies
        </Styled.LegalLink>
        <span aria-hidden='true'>|</span>
        <Styled.LegalLink
          as='button'
          data-test='footer-cookie-preferences'
          onClick={(evt) => onCookiePreferencesClick(evt)}>
          Cookie preferences
        </Styled.LegalLink>
        <span aria-hidden='true'>|</span>
        <Styled.LegalLink
          data-test='footer-terms-and-conditions'
          href='/help/terms-and-conditions/'
          target={target}
          onClick={(evt) => onClick(evt, 'termsAndConditions')}>
          Terms &amp; conditions
        </Styled.LegalLink>
      </p>
      <p className='no-line-height' data-test='footer-copyright'>
        &copy; Argos Limited {currentYear}. All Rights Reserved.
      </p>
    </Styled.Legal>
  )
}

LegalFooter.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'checkout'])
}

LegalFooter.defaultProps = {
  onClick: () => {},
  variant: 'default'
}

export default LegalFooter
